<template>
    <router-link :to="{name: target}" class="i-con-h-a">

                <span class="nav-icon">
		                    <i class="i-con" :class="icon"></i>
		                  </span>
        <span class="nav-text">{{title}}</span>
    </router-link>
</template>

<script>
    export default {
        name: "MainMenuElement",
        props: {
            title: {
                type: String,
                required: true
            },
            target: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: true
            },
            count: {
                type: Number
            }
        }
    }
</script>

<style scoped lang="scss">

    @import '~styles/colors';

    .router-link-exact-active {
        color: #553F7A;
    }

    .icon {
        width: 2rem;
        text-align: center;
        margin-right: 0.5rem;
        color: $menu-icon-color;
        font-size: 1.15rem;
    }

    .count {
        display: inline-block;
        width: 30px;
        background-color: $menu-icon-color;
        color: white;
        border-radius: 14px;
        text-align: center;
        font-size: 0.8rem;
    }

    a:hover {
        text-decoration: none;
    }
</style>